<template>
  <div class="gallery">
    <div class="container">
      <!-- <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <iframe width="100%" class="mb-4" height="275" src="https://www.youtube.com/embed/pcuPXliBTcE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <div
          class=""
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="flex-wrap row d-flex justify-content-center">
            <div
              class=""
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="image.th || image.full" />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
      <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
      <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="left control" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="right control" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{
                preview.copyright.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1,
      },
      gallery: [
        {
          className: "col-md-12",
          items: [
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung__14-06038.jpg?updatedAt=1630337504343",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung__11-05850.jpg?updatedAt=1630337503568",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung__12-06024.jpg?updatedAt=1630337503978",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung__5-05608.jpg?updatedAt=1630337502758",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-12 order-md-0"
            },


            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_2-.jpg?updatedAt=1630337501911",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-12 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_5-.jpg?updatedAt=1630337502193",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-12 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_5-.jpg?updatedAt=1630337501043",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-12 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_1-.jpg?updatedAt=1630337501716",
              transition: "fade-down-right",
              class: "col-6 col-md-4  order-12 order-md-0"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/PicsArt_08-11-12.59.13.jpg?updatedAt=1630337500872",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-12 order-md-10"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/PicsArt_08-11-01.15.50.jpg?updatedAt=1630337500733",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-12 order-md-10"
            },



            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/DSC05058.jpg?updatedAt=1630337500605",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_6-.jpg?updatedAt=1630337502464",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung__7-05640.jpg?updatedAt=1630337503375",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_7-.jpg?updatedAt=1630337501252",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung_-.jpg?updatedAt=1630337504726",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tedi-trisna/tedi_bali_agung__18-06184.jpg?updatedAt=1630337504467",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
          ],
        },
      ],
      preview: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    },
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach((items) => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map((item) => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    },
  },
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
